/* eslint-disable @typescript-eslint/no-explicit-any */

/** Read a plan feature from API `features` or `rawFeatures`, trying each key in order. */
export function getPlanFeature(plan: any, ...keys: string[]): unknown {
  const sources = [plan?.features, plan?.rawFeatures];
  for (const key of keys) {
    for (const source of sources) {
      if (source?.[key] !== undefined && source?.[key] !== null) {
        return source[key];
      }
    }
  }
  return undefined;
}

export function getBookingCalendarValue(plan: any): unknown {
  return getPlanFeature(plan, 'bookingCalendar', 'BookingCalendar');
}

export function isBookingCalendarEnabled(plan: any): boolean {
  return Boolean(getBookingCalendarValue(plan));
}

export function getPromoToolsValue(plan: any): unknown {
  return getPlanFeature(
    plan,
    'promoTools',
    'DiscountsPromoTools',
    'promo',
    'discountsPromoTools'
  );
}

export function getMessagingValue(plan: any): unknown {
  return getPlanFeature(plan, 'messaging', 'MessagingSystem');
}

export function getAnalyticsValue(plan: any): unknown {
  return getPlanFeature(plan, 'analytics', 'Analytics');
}

export function formatPlanFeatureLabel(value: unknown): string {
  if (value == null) return '—';
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  if (typeof value === 'string') {
    return value.charAt(0).toUpperCase() + value.slice(1).replace(/-/g, ' ');
  }
  return String(value);
}

export function formatPromoToolsCell(value: unknown): string | boolean {
  if (value == null || value === false) return false;
  if (typeof value === 'boolean') return value;
  return formatPlanFeatureLabel(value);
}

export function formatMessagingCell(value: unknown): string | boolean {
  if (value == null || value === false) return false;
  if (typeof value === 'boolean') return value;
  return String(value).replace(/-/g, ' ');
}

/** Raw `limits.featuredListings` — same source as BecomeProviderModal. */
export function getFeaturedListingsLimit(plan: any): string | number {
  const raw = plan?.limits?.featuredListings;
  if (raw === null || raw === undefined) return '—';
  return raw;
}

export function isFeaturedListingsIncluded(plan: any): boolean {
  const raw = plan?.limits?.featuredListings;
  if (raw === null || raw === undefined) return false;
  if (typeof raw === 'number') return raw !== 0;
  if (typeof raw === 'string') {
    return raw !== '0' && raw !== '0/month';
  }
  return Boolean(raw);
}

export function isPopularPlan(plan: any): boolean {
  return Boolean(plan?.isPopular ?? plan?.popular);
}
